export default "__VITE_ASSET__CfXOZIyo__"